<!--  -->
<template>
  <div class="news-box">
    <div class="top-wrapper">
      <head-box :title="title" class="head-box"></head-box>
      <router-link class="more" to="/newsCenter"
        ><span class="text">更多</span
        ><span><img src="../../../assets/images/double_arrow.png"/></span
      ></router-link>
    </div>
    <div class="news-wrapper">
      <div
        class="new-item"
        v-for="(item, index) in newsInfo"
        @click="toNewPage(item.owNewsId)"
        :key="index"
      >
        <div class="new-pic"><img :src="item.thumbUrl" /></div>
        <div class="new-title">{{ item.title }}</div>
        <div class="new-text">{{ item.summaryInfo }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import headBox from "../../../components/header/head";
import http from "../../../api/http.js";
import apiUrl from "../../../api/apiUrl.js";

export default {
  data() {
    return {
      title: "默尼大事件",
      newsInfo: []
    };
  },

  props: [],

  watch: {},

  components: {
    headBox
  },

  computed: {},

  created() {
    this.fetchNewsInfo();
  },

  methods: {
    toNewPage(id) {
      this.$router.push({ name: "NewsPage", query: { newsId: id } });
    },
    // 获取新闻页数据
    fetchNewsInfo() {
      const test = new Date().getTime();
      http.get(apiUrl.newsRecord).then(response => {
        const test2 = new Date().getTime();
        if (response.code == 0) {
          // response.data = response.data.concat(response.data);
          this.newsInfo = response.data;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.news-box {
  width: 100%;
  padding: 50px 350px 0 350px;
  // min-height: 54vh;
  box-sizing: border-box;
  .top-wrapper {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    line-height: 25px;
    color: #ccc;
    position: relative\0;
    .head-box {
      display: inline-block;
    }
    .more {
      display: inline-block;
      color: #ccc;
    }
    .more:hover {
      color: #ccc;
      font-weight: 500;
      background: transparent;
    }

    span {
      img {
        vertical-align: text-top;
        width: 23px;
        height: 23px;
      }
    }
  }
  .news-wrapper {
    width: 100%;
    margin-top: 22px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .new-item:nth-child(3) {
    }
    .new-item {
      display: inline-block;
      text-align: left;
      width: 380px;
      padding: 0;
      margin: 0;
      margin-bottom: 30px;
      cursor: pointer;
      .new-pic {
        width: 100%;
        height: 260px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .new-title {
        margin: 19px 0 10px 0;
        color: #333;
        font-size: 20px;
        line-height: 28px;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .new-text {
        color: #666;
        font-size: 20px;
        line-height: 28px;
        overflow: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/newsBox.vue